export default __webpack_public_path__ + "static/media/logo-card-small.889d6c7c.png";